import React from "react";
import eye from "../../../../assets/logos/eye.svg";
import chevron from "../../../../assets/logos/chevron.svg";
import vignette4 from "../../../../assets/images/vignette4.jpg";

import en from "../../../../locales/en/translation.json";
import fr from "../../../../locales/fr/translation.json";
import dot from "../../../../assets/logos/dot_horizontal.svg";

export default class RepostsLine extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      shares: this.props.shares,
      lang: "en",
      trad: en,
    };
  }

  componentDidMount() {
    if (JSON.parse(localStorage.getItem("user"))) {
      this.setState(
        {
          user: JSON.parse(localStorage.getItem("user")),
        },
        () => {
          let lang = this.state.user.user.language;
          if (lang === "fr") {
            this.setState({ lang: "fr", trad: fr });
          }
        }
      );
    }
  }

  handleOpenMenuDot = (index) => {
    let id = `menu_reposts_${index}`;
    let menu = document.getElementById(id);
    if (menu.style.display === "block") {
      menu.style.display = "none";
    } else {
      menu.style.display = "block";
    }
  };
  handleCallBackLaunch = (type, action, index) => {
    console.log(type, action, index);
    if (action === "disliker") {
      this.handleDislike(type, action, index);
    } else {
      this.props.callBackEpingle(type, action, index);
    }
  };
  handleDislike = (type, action, index) => {
    console.log("dislike " + type, action, index);
  };

  render() {
    return (
      <div className="lastlike reposts">
        <h2>
          {this.state.trad.creatorRepost}{" "}
          <img style={{ marginLeft: "8px" }} src={chevron} alt="" />
        </h2>
        <div className="line">
          {this.state.shares != null &&
            this.state.shares.map((value, index) => (
              <div className="block_video" key={index}>
                <div className="menu">
                  <img
                    onClick={() => this.handleOpenMenuDot(index)}
                    src={dot}
                    alt=""
                  />
                  <ul id={`menu_reposts_${index}`}>
                    <li
                      onClick={() =>
                        this.handleCallBackLaunch("videos", "bug", index)
                      }
                    >
                      {this.state.trad.pDescriptionUtilisateur3}
                    </li>
                    <li
                      onClick={() =>
                        this.handleCallBackLaunch("videos", "contenu", index)
                      }
                    >
                      {this.state.trad.pDescriptionUtilisateur4}
                    </li>
                    <li
                      onClick={() =>
                        this.handleCallBackLaunch("videos", "disliker", index)
                      }
                    >
                      Disliker
                    </li>
                    {/*
                                            !this.state.myPage &&
                                            <>
                                                <li onClick={() => this.handleCallBackLaunch("videos", "save", index)}>{this.state.trad.pDescriptionUtilisateur5}</li>
                                            </>
                                        */}
                    <li
                      onClick={() =>
                        this.handleCallBackLaunch("videos", "share", index)
                      }
                    >
                      {this.state.trad.pDescriptionUtilisateur6}
                    </li>
                  </ul>
                </div>
                <div
                  className="img"
                  onClick={() => this.handleEditVideo(index)}
                >
                  <a href={`/video/${value.video.token}`}>
                    <img
                      src={
                        value.video.miniature !== null
                          ? import.meta.env.VITE_BACKEND_URL_IMG +
                            value.video.miniature
                          : vignette4
                      }
                      alt=""
                    />
                    <p className="time">{value.video.time}</p>
                  </a>
                </div>
                <div className="info_video">
                  <p className="title">{value.video.title}</p>
                  {value.user && value.user.nom_artiste && (
                    <p className="creator">{value.user.nom_artiste}</p>
                  )}
                  <p className="view">
                    <img src={eye} alt="" /> {value.video.vue}
                  </p>
                </div>
              </div>
            ))}
        </div>
      </div>
    );
  }
}
